import React, { useEffect, useState } from "react";
import { BASE_URL } from "../env";

export default function CodingQuesForm() {
	const [name, setName] = useState("");
	const [description, setdescription] = useState("");

	const [sampleInput, setsampleInput] = useState("");
	const [sampleOutput, setsampleOutput] = useState("");

	const [category, setCategory] = useState("");
	const [company, setCompany] = useState("");

	const [questionWeigh, setquestionWeigh] = useState("");
	const [questionCode, setquestionCode] = useState([]);
	// const [language, setlanguage] = useState("");
	// const [code, setcode] = useState("");

	// const [Ptestcases, setPtestcases] = useState([
	//     { name: "", code: "", output: "", language: "python" },
	// ]);
	// const [Ctestcases, setCtestcases] = useState([
	//     { name: "", code: "", output: "", language: "c" },
	// ]);
	// const [CPPtestcases, setCPPtestcases] = useState([
	//     { name: "", code: "", output: "", language: "cpp" },
	// ]);
	// const [Jtestcases, setJtestcases] = useState([
	//     { name: "", code: "", output: "", language: "java" },
	// ]);

	// const [Cname, setCname] = useState("");
	// const [Ccode, setCcode] = useState("");
	// const [Coutput, setCoutput] = useState("");

	// const [CPPname, setCPPname] = useState("");
	// const [CPPcode, setCPPcode] = useState("");
	// const [CPPoutput, setCPPoutput] = useState("");

	// const [Pname, setPname] = useState("");
	// const [Pcode, setPcode] = useState("");
	// const [Poutput, setPoutput] = useState("");

	// const [Jname, setJname] = useState("");
	// const [Jcode, setJcode] = useState("");
	// const [Joutput, setJoutput] = useState("");

	const [testcases, settestcases] = useState([]);
	const [courseId, setcourseId] = useState("");
	const [courses, setCourses] = useState([]);
	const [rerender, setrerender] = useState(false);

	useEffect(() => {
		fetch(BASE_URL + "/getallCourse")
			.then((res) => res.json())
			.then((data) => {
				//   console.log(data)
				setCourses(data?.courses);
			});
	}, []);

	// useEffect(() => {
	//   fetch(BASE_URL + "/GetAllQuestionAdmin", {
	//     headers: {
	//       "Content-Type": "Application/json",
	//     },
	//   })
	//     .then((res) => res.json())
	//     .then((data) => console.log(data));
	// }, []);

	const submitHandler = async () => {
		const data = {
			name,
			description,
			questionCode,
			testcases,
			sampleInput,
			sampleOutput,
			company,
			courseId,
			questionWeigh,
			category,
		};

		console.log(data);

		await fetch(BASE_URL + "/createQuestion", {
			method: "POST",
			headers: {
				"content-type": "application/json",
				Authorization: "Bearer " + localStorage.getItem("token"),
			},
			body: JSON.stringify(data),
		})
			.then((data) => data.json())
			.then((data) => {
				console.log(data.questions);
				alert(data.message);
			})
			.catch((err) => {
				console.log(err.response.data.message);
				alert(err.response.data.message);
			});
	};

	const handleAddFields = () => {
		setquestionCode((prev) => [...prev, { code: "", language: "" }]);
	};

	const handleRemoveFields = (index) => {
		let temp = questionCode.filter((rr, ind) => (ind != index ? rr : null));
		setquestionCode(temp);
	};

	const addLanguageInTestcases = () => {
		settestcases((prev) => [...prev, [{ language: "" }, []]]);
	};

	const addTestcaseInLanguage = (ind1) => {
		testcases[ind1][1] = [
			...testcases[ind1][1],
			{ code: "", name: "", output: "" },
		];
		setrerender(!rerender);
	};

	const removeTestcaseInLanguage = (ind1, ind2) => {
		testcases[ind1][1] = testcases[ind1][1].filter((rr, ind) =>
			ind2 != ind ? rr : null
		);
		setrerender(!rerender);
	};

	const testcaseChange = (e, ind1, ind2) => {
		testcases[ind1][1][ind2][`${e.target.name}`] = e.target.value;
		setrerender(!rerender);
	};

	const addlanguagecode = (e, index) => {
		questionCode[index][`${e.target.name}`] = e.target.value;
		setrerender(!rerender);
	};

	const testcasesLanguage = (e, ind1) => {
		testcases[ind1][0].language = e.target.value;
		setrerender(!rerender);
	};

	//   const handleAddPFields = () => {
	//     setPtestcases([
	//       ...Ptestcases,
	//       { name: Pname, code: Pcode, output: Poutput, language: "Python" },
	//     ]);
	//   };

	//   const handleRemovePFields = (id) => {
	//     const values = [...Ptestcases];
	//     values.splice(
	//       values.findIndex((value) => value.id === id),
	//       1
	//     );
	//     setPtestcases(values);
	//   };

	//   const handleAddCFields = () => {
	//     setCtestcases([
	//       ...Ctestcases,
	//       { name: Cname, code: Ccode, output: Coutput, language: "C" },
	//     ]);
	//   };

	//   const handleRemoveCFields = (id) => {
	//     const values = [...Ctestcases];
	//     values.splice(
	//       values.findIndex((value) => value.id === id),
	//       1
	//     );
	//     setCtestcases(values);
	//   };

	//   const handleAddCPPFields = () => {
	//     setCPPtestcases([
	//       ...CPPtestcases,
	//       { name: CPPname, code: CPPcode, output: CPPoutput, language: "C++" },
	//     ]);
	//   };

	//   const handleRemoveCPPFields = (id) => {
	//     const values = [...CPPtestcases];
	//     values.splice(
	//       values.findIndex((value) => value.id === id),
	//       1
	//     );
	//     setCPPtestcases(values);
	//   };

	//   const handleAddJFields = () => {
	//     setJtestcases([
	//       ...Jtestcases,
	//       { name: Jname, code: Jcode, output: Joutput, language: "Java" },
	//     ]);
	//   };

	//   const handleRemoveJFields = (id) => {
	//     const values = [...Jtestcases];
	//     values.splice(
	//       values.findIndex((value) => value.id === id),
	//       1
	//     );
	//     setJtestcases(values);
	//   };

	return (
		<>
			<div className="m-5 p-5">
				<h2 style={{ textAlign: "center" }}>Coding Question Form</h2>
				<h4>Course Id:</h4>{" "}
				<select
					className={`form-control`}
					aria-label="Default select example"
					name=""
					id=""
					value={courseId}
					onChange={(e) => {
						setcourseId(e.target.value);
					}}
				>
					<option value="">Select Course</option>
					{courses.map((val) => {
						return <option value={val?._id}>{val?.name}</option>;
					})}
				</select>
				<h4>Name:</h4>{" "}
				<input
					type="text"
					placeholder="name"
					onChange={(e) => setName(e.target.value)}
				/>
				<br />
				<h4>Description:</h4>
				<textarea
					type="text"
					placeholder="description"
					onChange={(e) => setdescription(e.target.value)}
				/>
				<br />
				<h4>Sample Input:</h4>
				<textarea
					type="text"
					placeholder="input"
					onChange={(e) => setsampleInput(e.target.value)}
				/>
				<br />
				<h4>Sample Output:</h4>
				<textarea
					type="text"
					placeholder="output"
					onChange={(e) => setsampleOutput(e.target.value)}
				/>
				<br />
				<h4>Category:</h4>
				<input
					type="text"
					placeholder="category"
					onChange={(e) => setCategory(e.target.value)}
				/>
				<br />
				<h4>Company:</h4>
				<input
					type="text"
					placeholder="company"
					onChange={(e) => setCompany(e.target.value)}
				/>
				<br />
				<br />
				<h4>Question Weight:</h4>
				<br />
				<input
					type="number"
					placeholder="question weigh"
					onChange={(e) => setquestionWeigh(e.target.value)}
				/>
				<br />
				<br />
				<hr />
				<hr />
				<hr />
				<hr />
				<hr />
				<br />
				<br />
				<h2>Question Code Array:</h2>
				<br />
				<br />
				{questionCode.map((inputField, index) => (
					<div key={index}>
						<p>Language:</p>
						<input
							name="language"
							placeholder="Language"
							required
							value={inputField.language}
							onChange={(event) => addlanguagecode(event, index)}
						/>
						<br />
						<p>Code:</p>{" "}
						<textarea
							rows="4"
							cols="100"
							name="code"
							placeholder="Code"
							required
							value={inputField.code}
							onChange={(event) => addlanguagecode(event, index)}
						/>
						&emsp; &emsp;
						<button onClick={() => handleRemoveFields(index)}>
							--
						</button>
						<hr />
					</div>
				))}
				<br />
				<button onClick={handleAddFields}>++</button>
				<br />
				<br />
				<br />
				<h2>Add Private testcases:</h2>
				<br />
				{testcases.map((inputField, ind1) => (
					<div key={ind1}>
						<br />
						<br />
						<h3>Language: </h3>
						<br />
						<input
							name="language"
							placeholder="Language"
							value={inputField[0].language}
							onChange={(e) => testcasesLanguage(e, ind1)}
						/>
						<br />
						<br />
						{inputField[1].map((inputField2, ind2) => (
							<>
								<p>Code:</p>
								<textarea
									rows="4"
									style={{ width: "100%" }}
									name="code"
									placeholder="Code"
									value={inputField2.code}
									onChange={(e) =>
										testcaseChange(e, ind1, ind2)
									}
								/>
								<br />
								<p>Name:</p>
								<input
									name="name"
									placeholder="Name"
									value={inputField2.name}
									onChange={(e) =>
										testcaseChange(e, ind1, ind2)
									}
								/>{" "}
								<br />
								<p>Output:</p>
								<textarea
									name="output"
									placeholder="Output"
									value={inputField2.output}
									onChange={(e) =>
										testcaseChange(e, ind1, ind2)
									}
								/>
								&emsp;
								<button
									onClick={() =>
										removeTestcaseInLanguage(ind1, ind2)
									}
								>
									--
								</button>
								<hr />
								<br />
								<br />
							</>
						))}
						<br />
						<br />

						<button onClick={() => addTestcaseInLanguage(ind1)}>
							{inputField[0].language} testcases++
						</button>
						<hr />
						<hr />
						<br />
						<br />
					</div>
				))}
				<button onClick={addLanguageInTestcases}>
					{" "}
					Add another language testcases ++
				</button>
				<hr />
				{/* <h2>Python Test Cases Array:</h2>
                <br />
                {Ptestcases.map((inputField) => (
                    <div key={inputField.id}>
                        <p>Code:</p>
                        <textarea
                            rows="4"
                            style={{ width: "100%" }}
                            name="Pcode"
                            placeholder="PCode"
                            onChange={(event) => setPcode(event.target.value)}
                        />
                        <br />
                        <p>Name:</p>
                        <input
                            name="Pname"
                            placeholder="Pname"
                            onChange={(event) => setPname(event.target.value)}
                        />{" "}
                        <br />
                        <p>Output:</p>
                        <input
                            name="Poutput"
                            placeholder="Poutput"
                            onChange={(event) => setPoutput(event.target.value)}
                        />
                        &emsp;
                        <button onClick={handleAddPFields}>++</button>
                        &emsp;
                        <button
                            // disabled={inputFields.length === 1}
                            // onClick={() => handleRemovePFields(codeArr.id)}
                        >
                            --
                        </button>
                    </div>
                ))}
                <br />
                <br />
                <h2>C Test Cases Array:</h2>
                <br />
                {Ctestcases.map((inputField) => (
                    <div key={inputField.id}>
                        <p>Code:</p>
                        <textarea
                            rows="4"
                            style={{ width: "100%" }}
                            name="Ccode"
                            placeholder="CCode"
                            onChange={(event) => setCcode(event.target.value)}
                        />
                        <br />
                        <p>Name:</p>
                        <input
                            name="Cname"
                            placeholder="Cname"
                            onChange={(event) => setCname(event.target.value)}
                        />{" "}
                        <br />
                        <p>Output:</p>
                        <input
                            name="Coutput"
                            placeholder="Coutput"
                            onChange={(event) => setCoutput(event.target.value)}
                        />
                        &emsp;
                        <button onClick={handleAddCFields}>++</button>
                        &emsp;
                        <button
                            // disabled={inputFields.length === 1}
                            // onClick={() => handleRemoveCFields(codeArr.id)}
                        >
                            --
                        </button>
                    </div>
                ))}
                <br />
                <br />
                <h2>CPP Test Cases Array:</h2>
                <br />
                {CPPtestcases.map((inputField) => (
                    <div key={inputField.id}>
                        <p>Code:</p>
                        <textarea
                            rows="4"
                            style={{ width: "100%" }}
                            name="CPPcode"
                            placeholder="CPPCode"
                            onChange={(event) => setCPPcode(event.target.value)}
                        />
                        <br />
                        <p>Name:</p>
                        <input
                            name="CPPname"
                            placeholder="CPPname"
                            onChange={(event) => setCPPname(event.target.value)}
                        />{" "}
                        <br />
                        <p>Output:</p>
                        <input
                            name="CPPoutput"
                            placeholder="CPPoutput"
                            onChange={(event) => setCPPoutput(event.target.value)}
                        />
                        &emsp;
                        <button onClick={handleAddCPPFields}>++</button>
                        &emsp;
                        <button
                            // disabled={inputFields.length === 1}
                            // onClick={() => handleRemoveCPPFields(codeArr.id)}
                        >
                            --
                        </button>
                    </div>
                ))}
                <br />
                <br />
                <h2>Java Test Cases Array:</h2>
                <br />
                {Jtestcases.map((inputField) => (
                    <div key={inputField.id}>
                        <p>Code:</p>
                        <textarea
                            rows="4"
                            style={{ width: "100%" }}
                            name="Jcode"
                            placeholder="JCode"
                            onChange={(event) => setJcode(event.target.value)}
                        >
                        </textarea>
                        <br />
                        <p>Name:</p>
                        <input
                            name="Jname"
                            placeholder="Jname"
                            onChange={(event) => setJname(event.target.value)}
                        />{" "}
                        <br />
                        <p>Output:</p>
                        <input
                            name="Joutput"
                            placeholder="Joutput"
                            onChange={(event) => setJoutput(event.target.value)}
                        />
                        &emsp;
                        <button onClick={handleAddJFields}>++</button>
                        &emsp;
                        <button
                            // disabled={inputFields.length === 1}
                            // onClick={() => handleRemoveJFields(codeArr.id)}
                        >
                            --
                        </button>
                    </div>
                ))} */}
				<br />
				<br />
				<button onClick={() => submitHandler()}>Submit</button>
				{/* </form> */}
			</div>
		</>
	);
}
